import { T } from '@/ui/tokens';

interface LegalModalProps {
  title: string;
  html: string;
  onClose: () => void;
}

export function LegalModal({ title, html, onClose }: LegalModalProps) {
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.7)', display: 'flex',
      alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: T.surface, width: '100%', maxWidth: 480,
        maxHeight: '85dvh', display: 'flex', flexDirection: 'column',
        borderRadius: `${T.radiusXl}px ${T.radiusXl}px 0 0`,
        overflow: 'hidden',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px 12px', borderBottom: `1px solid ${T.line}`,
        }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: T.text }}>{title}</span>
          <button onClick={onClose} style={{
            width: 32, height: 32, borderRadius: '50%',
            background: T.surface2, border: `1px solid ${T.line}`,
            color: T.textDim, fontSize: 18, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}>&times;</button>
        </div>
        <div style={{
          flex: 1, overflowY: 'auto', padding: '16px 20px 24px',
          WebkitOverflowScrolling: 'touch',
        }}>
          <div style={{
            color: T.textDim, fontSize: 13, lineHeight: 1.7,
          }} dangerouslySetInnerHTML={{ __html: html }}/>
        </div>
      </div>
    </div>
  );
}
